export default __webpack_public_path__ + "static/media/winston-rescue.9a122297.mp3";